import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { AMAZON_URL } from "../lib/site";

const EASE = [0.22, 1, 0.36, 1];

export const FinalCTA = () => (
  <section
    data-testid="final-cta-section"
    className="relative overflow-hidden bg-[#20C9C3] py-20 sm:py-28"
  >
    <svg
      className="pointer-events-none absolute top-0 left-0 h-20 w-full text-white/15"
      viewBox="0 0 1440 80"
      fill="none"
      preserveAspectRatio="none"
    >
      {[0, 1, 2].map((i) => (
        <path
          key={i}
          d={`M0 ${18 + i * 20} C 360 ${4 + i * 20}, 1080 ${34 + i * 20}, 1440 ${12 + i * 20}`}
          stroke="currentColor"
          strokeWidth="1"
        />
      ))}
    </svg>
    <svg
      className="pointer-events-none absolute bottom-0 left-0 h-20 w-full text-white/15"
      viewBox="0 0 1440 80"
      fill="none"
      preserveAspectRatio="none"
    >
      {[0, 1, 2].map((i) => (
        <path
          key={i}
          d={`M0 ${26 + i * 16} C 360 ${44 + i * 16}, 1080 ${14 + i * 16}, 1440 ${30 + i * 16}`}
          stroke="currentColor"
          strokeWidth="1"
        />
      ))}
    </svg>
    <div className="pointer-events-none absolute -top-24 right-10 h-72 w-72 rounded-full bg-white/10 blur-[90px]" />

    <div className="relative mx-auto max-w-3xl px-5 sm:px-8 text-center">
      <motion.div
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.85, ease: EASE }}
      >
        <div className="mb-6 flex items-center justify-center gap-3">
          <span className="h-px w-10 bg-[#C5A253]" />
          <span className="h-2 w-2 rotate-45 bg-[#C5A253]" />
          <span className="h-px w-10 bg-[#C5A253]" />
        </div>
        <h2
          data-testid="cta-heading"
          className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-white"
        >
          What Are Your Books Telling You?
        </h2>
        <p
          data-testid="cta-text"
          className="mx-auto mt-6 max-w-xl text-base md:text-lg leading-relaxed text-white/90"
        >
          Start with the 50 bookkeeping red flags every business owner should
          know.
        </p>
        <div className="mt-10">
          <a
            href={AMAZON_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-buy-button"
            className="group inline-flex items-center gap-2.5 rounded-full bg-[#C5A253] px-10 py-4 text-sm font-bold uppercase tracking-[0.12em] text-[#1E2A2B] shadow-[0_18px_40px_rgba(30,42,43,0.3)] transition-[background-color,transform,box-shadow] duration-300 hover:bg-[#D4B469] hover:-translate-y-1 hover:shadow-[0_24px_50px_rgba(30,42,43,0.35)]"
          >
            Buy the Book on Amazon
            <ArrowUpRight className="h-[18px] w-[18px] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);
